import { render, staticRenderFns } from "./EventChatPhotosReveals.vue?vue&type=template&id=533e5618&"
import script from "./EventChatPhotosReveals.vue?vue&type=script&lang=js&"
export * from "./EventChatPhotosReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports